import styled from 'styled-components'

const Wrapper = styled.div`
  width:100%;
  background: #D6EE47;
  padding:91px 0px 92px;
  position:relative;
  top:-3px;
`
const Icon = styled.img`
  width:18px;
  height:18px;
  margin-left:4px;
`
const Inner = styled.div`
  max-width:1084px;
  width:90%;
  margin:0 auto;
  display:flex;
  justify-content:space-between;
  flex-wrap:wrap;
`
const Leftside = styled.span`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 72px;
  line-height: 80px;
  letter-spacing: -1px;
  text-transform: uppercase;
  color: #0F0F0E;
  @media(max-width:820px){
    line-height:60px;
  }
  @media(max-width:500px){
    font-size:50px;
  }
  @media(max-width:360px){
    font-size:45px;
  }
`
const Button = styled.div`
  max-width:523px;
  width:100%;
  background:#5F47EE;
  border-radius:28px;
  padding:16px 0px;
  text-align:center;
  margin-top:40px;
  
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;
  color: #FCFCFC;
  cursor:pointer;
  & a {
    color:white;
  }
`
const Text = styled.span`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 1px;
  color: #0F0F0E;
`
const Rightside = styled.div`
  padding: 50px 0 0;
  display:block;
`
const Watch = () => {
  return (
    <Wrapper>
      <Inner>
        <Leftside>what the<br /> community<br /> is saying</Leftside>

        <Rightside>
          <Text>A curated video playlist about Robust protocol</Text>
          <a
            rel="noreferrer"
            target="_blank"
            style={{ textDecoration: 'none' }}
            href='https://www.youtube.com/playlist?list=PLmpyla2d8mfQP_5-pd-Jje0eo-QS4ryQC'>
            <Button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              WATCH
              <Icon src="assets/svg/gointo2.png" style={{ width: "22px", height: "22px" }} />
            </Button>
          </a>
        </Rightside>
      </Inner>
    </Wrapper>
  )
}

export default Watch